import { render, staticRenderFns } from "./add-permission.vue?vue&type=template&id=46dc8fd0&"
import script from "./add-permission.vue?vue&type=script&lang=js&"
export * from "./add-permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports